import { render, staticRenderFns } from "./User-data.vue?vue&type=template&id=7a1f8d33"
import script from "./User-data.vue?vue&type=script&lang=js"
export * from "./User-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports